import React from 'react'
import { Script } from 'gatsby'
import { getCookies } from 'component/Helpers/getCookies'

export function ScriptTagmanager() {
	if (process.env.NODE_ENV === 'production') {
		const cookieFbc = getCookies('_fbc') ? getCookies('_fbc') : null
		const cookieFbp = getCookies('_fbp') ? getCookies('_fbp') : null

		return (
			<>
				<Script
					key="tagmanager-script"
					strategy="idle"
					dangerouslySetInnerHTML={{
						__html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NZXX7CC');`,
					}}
				/>

				<Script
					key="gtag-script"
					strategy="idle"
					dangerouslySetInnerHTML={{
						__html: `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}gtag('js', new Date()); gtag('config', 'G-V24Z24HJ0H', {'send_page_view': false, 'cookie_domain': '.aurum.com.br', 'cookie_flags': 'SameSite=None;Secure', 'cookie_fbc': '${cookieFbc}', 'cookie_fbp': '${cookieFbp}'});`,
					}}
				/>
			</>
		)
	} else {
		console.log('GTM pausado em desenvolvimento')
		return null
	}
}
